export const KB_UPDATE_PROPOSAL_PROMPT_VERSION = '1.0.0'

export type KbUpdateProposalPromptInput = {
  referenceNumber: string
  aiDraft: string | null
  expertResponse: string
  existingKnowledgeTitles: string[]
  resolutionSeverity?: string
  resolutionConcerns?: string
}

export function buildKbUpdateProposalPrompt(input: KbUpdateProposalPromptInput): {
  system: string
  user: string
} {
  const resolutionContext = [
    input.resolutionSeverity && `Resolution severity: ${input.resolutionSeverity}`,
    input.resolutionConcerns && `Concern type: ${input.resolutionConcerns}`,
  ].filter(Boolean).join('\n')

  const priorityNote = input.resolutionConcerns === 'Knowledge gap'
    ? ' Proposals for "Knowledge gap" concern type should be flagged as high-priority KB additions.'
    : ''

  return {
    system:
      `You propose concise knowledge base updates from expert ticket responses. Only propose durable operational knowledge, not one-off ticket details.${priorityNote}`,
    user: [
      `Ticket: ${input.referenceNumber}`,
      resolutionContext ? `\nResolution classification:\n${resolutionContext}` : '',
      '',
      'AI draft:',
      input.aiDraft ?? 'No AI draft was available.',
      '',
      'Expert response:',
      input.expertResponse,
      '',
      'Existing KB titles:',
      input.existingKnowledgeTitles.length ? input.existingKnowledgeTitles.join('\n') : 'None',
      '',
      'Return whether a KB update is needed. If yes, provide a title, slug, markdown body, and reasoning trace.',
    ].filter((line) => line !== '').join('\n'),
  }
}
